import type { FaireProductEntity } from "../../entity_types/product";

export const p_gz735qtacg: FaireProductEntity = {
  token: "p_gz735qtacg",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Garnet (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/554c902b46f4181808ee6cf1e665e7d3b38be0bce258561d8224fd38d848d78c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/daca4f2ae013d61651557d7230d02a8255324c102708e6c8bf6d80565d0cc429.jpeg",
    "https://cdn.faire.com/fastly/186d8444305aa4e2e68d707620847f8bb7859c813c6c031c0456a9000fd86a69.jpeg",
    "https://cdn.faire.com/fastly/3896a4fae2131316e1bd39b0584d0c4f7e593c7e61e5b4c7260fc8aa474ff46a.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee—crafted from deadstock Pima cotton and designed with a bold jacquard knit. Lightweight, breathable, and easy to style, it’s a wardrobe essential.\n\n * Slightly cropped and boxy body \n * 100% Cotton \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:28.553Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
